<template>
  <div class="relative rounded-lg border bg-cime-white p-6" :class="classes" @click="onSelect()">
    <div v-if="$slots.tag" class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-[13px]">
      <slot name="tag" />
    </div>
    <slot :is-active="isActive" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface Props {
  modelValue: string | number | null;
  value: string | number;
  hasError?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  hasError: false,
});

const emit = defineEmits(['update:modelValue']);

const isActive = computed(() => props.modelValue === props.value);

const onSelect = () => {
  if (!isActive.value) {
    emit('update:modelValue', props.value);
  }
};

const classes = computed(() => {
  const cursor = 'cursor-pointer';
  const shadow = 'hover:shadow-md transition';
  const border = `rounded-lg border ${props.hasError && !isActive.value ? 'border-error-dark' : 'border-cime-gray-light'}`;
  const ringColor = `ring-2 ring-offset-2 ${props.hasError ? 'ring-error-dark' : 'ring-secondary-500'}`;

  if (!isActive.value) {
    return `${cursor} ${shadow} ${border}`;
  }

  return `${cursor} ${shadow} ${border} ${ringColor}`;
});
</script>
